import { type MutationFunction } from '@tanstack/react-query';

import { Api } from '@/utils/api';
import type { InAppNotificationApiRecord } from '@/types/inAppNotification';

type MarkInAppNotificationSeen = MutationFunction<
  InAppNotificationApiRecord | undefined,
  number
>;

/**
 * Idempotent server-side — the earliest sighting wins — so a retry or a
 * double-click is harmless. The response carries the updated resource but no
 * `meta`, so the unseen count has to be adjusted locally.
 */
export const markInAppNotificationSeen: MarkInAppNotificationSeen = async (id) => {
  const response = await Api.patch<InAppNotificationApiRecord>(
    `/api/notifications/in_app/${id}/seen`,
  );

  return response.data;
};
